import React, {useState} from 'react';
import {Autocomplete, Backdrop, Box, Fade, Modal, TextField} from "@mui/material";
import Loader from "../BlueButton/Loader.js";
import upload from "../../assets/img/upload.png";
import {useSelector} from "react-redux";
import {word} from "../../word.js";
import sendFile from "../../assets/img/sendFile.png";
import {REACT_APP_API_URL} from "../../config.js";
import qs from "query-string";
import SuccessToast from "../BlueButton/SuccessToast.js";
import ErrorToast from "../BlueButton/ErrorToast.js";
import Api from "../../Api.js";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 600 ? 600 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p:4,
    height: 'auto',
    overflow: 'auto',
    maxHeight: '97vh'
};

const profession = localStorage.getItem("profession");
function AddFile({setOpen,open,getData}) {
    const organization = useSelector((state) => state.task.companies);

    const [name, setName] = useState('');
    const [file, setFile] = useState(null);
    const [company, setCompany] = useState('');
    const [submit, setSubmit] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const submitFile = async () => {
        try{
            setSubmit(true);
            setDisabled(true);

            let finalCompany = `${REACT_APP_API_URL}manager-company/${company}/`;

            if (!name || !file) {
                setDisabled(false);
                return;
            }
            const formData = new FormData();
            formData.append("name", name);
            formData.append("company", finalCompany);
            formData.append("file", file);
            await Api.postFile(formData)
            await getData()
            SuccessToast()
            setDisabled(false);
            setOpen(false)
        }catch (e) {
            ErrorToast()
            setDisabled(false)
        }
    };

    const keyPress =async (e) => {
        if (e.key === "Enter") {
            await submitFile();
        }
    };
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={!!open}
            onClose={() => setOpen(0)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className="">
                        <div className="close-line">
                            <div className="tool-tip-cont">
                                <div className="tool-tip">Փակել</div>
                                <i className="fas fa-times" onClick={() => setOpen(false)}/>
                            </div>
                        </div>
                        <div className="add-new-file-inside">
                            <div className={submit && !file ? "upload-file-item-error upload-file-item" : "upload-file-item"}>
                                <label>
                                    <input
                                        className="fileInput"
                                        type="file"
                                        onChange={(e) => {
                                            const value = e.target.files[0];
                                            if (value) {
                                                const reader = new FileReader();
                                                reader.onloadend = () => {
                                                    setFile(value);
                                                };
                                                reader.readAsDataURL(value);
                                            }
                                        }}
                                    />
                                    <img src={upload} alt="img" />
                                    <span>{file ? file.name : word.upload_file}</span>
                                </label>
                            </div>

                            {profession === "manager" && (
                                <Autocomplete
                                    loading={organization.length === 0}
                                    loadingText={
                                        <div className="auto-complete-loader">
                                            <Loader type="Oval" color="#101C2A" height={20} width={20} />
                                        </div>
                                    }
                                    getOptionKey={(option) => option.id}
                                    options={organization}
                                    onChange={(e, value) => setCompany(value?.id || '')}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            error={!company && submit}
                                            id={!company && submit ? "validation-outlined-input" : "outlined-helperText"}
                                            label="Կազմակերպություններ"
                                            fullWidth
                                            onKeyDown={keyPress}
                                        />
                                    )}
                                />
                            )}

                            <TextField
                                error={!name && submit}
                                id={!name && submit ? "validation-outlined-input" : "outlined-helperText"}
                                onChange={(e) => setName(e.target.value)}
                                label={word.name_file}
                                fullWidth
                                onKeyDown={keyPress}
                            />

                            {disabled ? (
                                <div className="loader-margin-small">
                                    <Loader size={20} />
                                </div>
                            ) : (
                                <img alt="img" src={sendFile} onClick={submitFile} />
                            )}
                        </div>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default AddFile;